import { Button } from 'antd'

type CsvExportParam = {
  data: any[]
  filename?: string
  children?: any
}

const CSVExporter = ({ data, filename, children }: CsvExportParam) => {
  const handleExport = () => {
    if (!data || data.length === 0) {
      return
    }

    const headers = Object.keys(data[0])
    const csvContent = [
      headers.join(','),
      ...data.map(row =>
        headers
          .map(header => {
            let cell = row[header] ?? ''
            cell = String(cell)
            if (/^[=+\-@]/.test(cell)) {
              cell = `'${cell}`
            }
            if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
              cell = `"${cell.replace(/"/g, '""')}"`
            }
            return cell
          })
          .join(','),
      ),
    ].join('\n')

    const blob = new Blob(['\ufeff' + csvContent], {
      type: 'text/csv;charset=utf-8;',
    })

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename || 'export.csv'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  return (
    data?.length > 0 && (
      <Button onClick={handleExport} type="primary">
        {children || 'Export CSV'}
      </Button>
    )
  )
}

export default CSVExporter
